/**
 * Feel free to use this file if you need javascript that is only
 * supposed to load on the front-end with your block.
 *
 * For instance, this can be handy if you want to add some interaction or slider
 * functionality not appropriate for the editor experience.
 */

// eslint-disable-next-line no-unused-vars
import Swiper from 'swiper';
import { Pagination, Autoplay, Keyboard } from 'swiper/modules';

Swiper.use( [ Pagination, Autoplay, Keyboard ] );

const testimonialSliders = document.querySelectorAll( '.wp-block-qala-blocks-testimonials' );

testimonialSliders.forEach( ( sliderInstance, index ) => {
	const swiperSelector = sliderInstance.querySelector( '.swiper' );
	swiperSelector.classList.add( 'testimonials-slider-' + index );

	const sliderAutoplay = sliderInstance.classList.contains( 'autoplay' )
		? {
			delay: 5000,
			disableOnInteraction: false,
		}
		: false;

	const sliderPagination = sliderInstance.classList.contains( 'has-pagination' )
		? {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
			renderBullet: ( bulletIndex, className ) => {
				return `<span class="${ className }"><span class="${ className }--inner"></span></span>`;
			},
		}
		: false;

	let mobileSlidesPerView = sliderInstance.dataset.columns < '2' ? sliderInstance.dataset.columns : 2;

	if ( sliderInstance.dataset?.singleMobileSlide ) {
		mobileSlidesPerView = 1;
	}

	const sliderKeyboardEnabled = sliderInstance.getAttribute( 'data-keyboard' ) === 'true';

	// if using loop mode, check if we need to add duplicates:
	if ( sliderInstance.classList.contains( 'has-loop' ) ) {
		function duplicateSlides( slides ) {
			slides.forEach( slide => {
				const clonedSlide = slide.cloneNode( true );
				clonedSlide.classList.add( 'swiper-slide-duplicated' );
				sliderInstance.querySelector( '.swiper-wrapper' ).appendChild( clonedSlide );
			} );

			const newNumberSlides = sliderInstance.querySelectorAll( '.swiper-slide' ).length;

			// if needed, duplicate again so loop works without console warnings.
			if ( newNumberSlides <= numberColumns ) {
				duplicateSlides( slides );
			}
		}

		const slides = sliderInstance.querySelectorAll( '.swiper-slide' );
		const numberSlides = slides.length;
		const numberColumns = parseInt( sliderInstance.getAttribute( 'data-columns' ) );

		// if number of slides is equal or less than columns, duplicate them all so loop works in swiper v9+
		if ( numberSlides <= numberColumns ) {
			duplicateSlides( slides );
		}
	}

	new Swiper( '.testimonials-slider-' + index, {
		createElements: true,
		loop: sliderInstance.classList.contains( 'has-loop' ),
		slidesPerView: 1,
		spaceBetween: 60,
		autoplay: sliderAutoplay,
		breakpoints: {
			375: {
				slidesPerView: mobileSlidesPerView,
			},
			768: {
				slidesPerView: sliderInstance.dataset.columns < '3' ? sliderInstance.dataset.columns : 3,
			},
			1024: {
				slidesPerView: sliderInstance.dataset.columns,
			},
		},
		pagination: sliderPagination,
		keyboard: {
			enabled: sliderKeyboardEnabled ? true : false,
		},
	} );
} );
